/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  contracts: [],
  sections: [],
  sales: [],
  document: null,
  error: '',
  loading: false,
};

export const digitalizationSlice = createSlice({
  name: 'digitalization',
  initialState,
  reducers: {
    initContracts: (state) => {
      state.contracts = [];
      state.error = '';
    },
    successContracts: (state, action) => {
      state.contracts = action.payload;
      state.error = '';
    },
    initSections: (state) => {
      state.sections = [];
      state.error = '';
    },
    successSections: (state, action) => {
      state.sections = action.payload;
      state.error = '';
    },
    initSales: (state) => {
      state.sales = [];
      state.error = '';
    },
    successSales: (state, action) => {
      state.sales = action.payload;
      state.error = '';
    },
    initDocument: (state) => {
      state.document = null;
      state.error = '';
    },
    successDocument: (state, action) => {
      state.document = action.payload;
      state.error = '';
    },
    error: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = '';
    },
    clear: (state) => {
      state.contracts = [];
      state.sections = [];
      state.sales = [];
      state.document = null;
      state.error = '';
    },
  },
});

export const digitalizationActions = digitalizationSlice.actions;

export default digitalizationSlice.reducer;
